import React from 'react';
import { Link } from 'react-router-dom';
import { Dialog } from '../portal/Dialog';
import { Button } from '../ui/Button';
import { Field, inputClass, ConsentCheckbox } from '../ui/Field';
import { useAcademy } from '../../context/Academy';
import { validateEmail } from '../../lib/leads';
import type { Learner } from '../../types/academy';
const COUNTRIES = ['Botswana', 'Cameroon', "Côte d'Ivoire", 'Egypt', 'Ethiopia', 'Ghana', 'Kenya', 'Malawi', 'Morocco', 'Mozambique', 'Namibia', 'Nigeria', 'Rwanda', 'Senegal', 'Sierra Leone', 'South Africa', 'Tanzania', 'Uganda', 'Zambia', 'Zimbabwe', 'United Kingdom', 'United States', 'Other'];
interface JoinDialogProps {
  open: boolean;
  onClose: () => void;
  /** Called once the learner exists, so the caller can finish the action that prompted sign up. */
  onJoined: (learner: Learner) => void;
  courseTitle?: string;
}
export function JoinDialog({
  open,
  onClose,
  onJoined,
  courseTitle
}: JoinDialogProps) {
  const {
    join,
    pendingReferral
  } = useAcademy();
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [country, setCountry] = React.useState('');
  const [organisation, setOrganisation] = React.useState('');
  const [consent, setConsent] = React.useState(false);
  const [errors, setErrors] = React.useState<Record<string, string>>({});
  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const next: Record<string, string> = {};
    if (!name.trim()) next.name = 'Please enter your name.';
    const emailError = validateEmail(email);
    if (emailError) next.email = emailError;
    if (!country) next.country = 'Please choose your country.';
    if (!consent) next.consent = 'Please accept the terms to continue.';
    setErrors(next);
    if (Object.keys(next).length) return;
    onJoined(join({
      name,
      email,
      country,
      organisation
    }));
  };
  return <Dialog open={open} onClose={onClose} title="Create your free account" description={courseTitle ? `You will be enrolled in ${courseTitle} straight away.` : 'Every course is free.'} data-id="element-444" data-mp="27a4i9zvhyrkn">
      <form onSubmit={onSubmit} noValidate className="space-y-5" data-id="element-445" data-mp="19v1crfmgihmq">
        {pendingReferral && <p className="rounded-sm bg-charcoal px-4 py-3 text-small text-body" data-id="element-446" data-mp="1dwmlqpvvebrn">
            You were invited with referral code <span className="font-medium text-ink" data-id="element-447" data-mp="1iv6cd3lesbqc">{pendingReferral}</span>.
          </p>}
        <Field id="join-name" label="Full name" required error={errors.name} data-id="element-448" data-mp="m6zzxui8wf1i">
          <input id="join-name" value={name} onChange={e => setName(e.target.value)} autoComplete="name" className={inputClass} data-id="element-449" data-mp="q7254dn6vqlj" />
        </Field>
        <Field id="join-email" label="Email" required error={errors.email} data-id="element-450" data-mp="v5c1usokaz99">
          <input id="join-email" type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" className={inputClass} data-id="element-451" data-mp="zy55tec7i3ka" />
        </Field>
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-452" data-mp="7epvd5u7hn1d">
          <Field id="join-country" label="Country" required error={errors.country} data-id="element-453" data-mp="3w1mh1l5s7usx">
            <select id="join-country" value={country} onChange={e => setCountry(e.target.value)} className={inputClass} data-id="element-454" data-mp="3r3ku2p58jbc6">
              <option value="" data-id="element-455" data-mp="3m36p5fyxkhid">Please choose</option>
              {COUNTRIES.map(c => <option key={c} value={c} data-id="element-456" data-mp="3i2egooxvugn5">
                  {c}
                </option>)}
            </select>
          </Field>
          <Field id="join-org" label="Organisation" data-id="element-457" data-mp="38dcycs3v7n60">
            <input id="join-org" value={organisation} onChange={e => setOrganisation(e.target.value)} className={inputClass} data-id="element-458" data-mp="38cl4blpx1xhu" />
          </Field>
        </div>
        <div data-id="element-459" data-mp="2yfgqc96858c4">
          <ConsentCheckbox id="join-consent" checked={consent} onChange={setConsent} data-id="element-460" data-mp="2yfyj2vtoh4fa">
            I agree to the Academy terms and the{' '}
            <Link to="/legal/privacy" className="underline underline-offset-2" data-id="element-461" data-mp="2ucsedsm7rlax">
              privacy notice
            </Link>
            .
          </ConsentCheckbox>
          {errors.consent && <p role="alert" className="mt-2 text-small text-[#FF8B7A]" data-id="element-462" data-mp="tc5mzc32e051">
              {errors.consent}
            </p>}
        </div>
        <Button type="submit" size="lg" className="w-full" data-id="element-463" data-mp="jm2mkqtm5jwo">
          {courseTitle ? 'Create account and enrol' : 'Create account'}
        </Button>
      </form>
    </Dialog>;
}